import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { customValidators, string, object } from '../../../Helpers/Validators/customValidators';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import States from '../../../Helpers/Lists/States';
import { InputMaskPhone } from '../../../Helpers/Formatters';
import { TextInput, SelectInput } from '../../../Helpers/Inputs';
import BackNext from '../../Common/SubComponents/BackNext';
import AppointmentDialog from '../Helpers/AppointmentDialog';
import { getBasicInfo, setBasicInfo } from '../../../../sessionStorage';

import '../../Common/BasicInfo.scss';

export default function BasicInfo(props) {

  const [isDialogOpen, setDialogOpen] = useState(false);
  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: BasicInfo.ValidationSchema(props.ageSpecs),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  // manually call setValue for fields that don't play nice with react-hook-form register
  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    // manually register fields for validation that don't play nice with react-hook-form register
    register({ name: 'state' });
    setValue('state', props.formState.state);
  }, [register]);

  const submitForm = () => {

    // Save formState to basicinfo
    var basicInfoFromSessionStorage = getBasicInfo();
    basicInfoFromSessionStorage.firstName = props.formState.firstName;
    basicInfoFromSessionStorage.lastName = props.formState.lastName;
    basicInfoFromSessionStorage.state = props.formState.state;
    basicInfoFromSessionStorage.phone = props.formState.phone;

    setBasicInfo(basicInfoFromSessionStorage);

    setDialogOpen(true);
  }

  return (
    <div className="basic-info d-flex justify-content-center">
      <Form onSubmit={handleSubmit(submitForm)}>
        <Form.Group>
          <TextInput
            name="firstName"
            id="firstName"
            label="First Name"
            value={props.formState.firstName}
            onChange={(e) => props.onFieldChange('firstName', e.target.value)}
            errors={errors.firstName}
            inputRef={register}
          />
        </Form.Group>

        <Form.Group>
          <TextInput
            name="lastName"
            id="lastName"
            label="Last Name"
            value={props.formState.lastName}
            onChange={(e) => props.onFieldChange('lastName', e.target.value)}
            errors={errors.lastName}
            inputRef={register}
          />
        </Form.Group>

        <Form.Group>
          <SelectInput
            name="state"
            id="state"
            value={props.formState.state}
            onChange={(e) => handleValueChange('state', e.target.value)}
            label="State"
            selectOptions={States()}
            errors={errors && errors.state}
            inputRef={register}
          />
        </Form.Group>

        <Form.Group>
          <TextInput
            name="phone"
            id="phone"
            label="Primary Phone"
            value={props.formState.phone}
            onChange={(e) => props.onFieldChange('phone', e.target.value)}
            errors={errors.phone}
            inputRef={register}
            InputProps={{
              inputComponent: InputMaskPhone,
            }}
          />
        </Form.Group>

        <BackNext
          hideBack={true}
          onBack={props.onBack}
          continueLabel={{ text: "REQUEST AN APPOINTMENT" }}
        />

        <AppointmentDialog
          open={isDialogOpen}
          onDialogClosed={() => {
            setDialogOpen(false);
          }}
          onNext={props.onNext}
          formState={props.formState}
        />
      </Form>
    </div>
  );
}

BasicInfo.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  hideBack: PropTypes.bool,
};

BasicInfo.ValidationSchema = (ageSpecs) => {
  return object().shape({
    firstName: string().required('First Name is required.'),
    lastName: string().required('Last Name is required.'),
    state: string().required('State is required.'),
    phone: customValidators.string()
      .required('Primary Phone is required')
      .isValidPhone('Primary Phone Number must be formatted as "(123) 456-7890"'),
  })
};

BasicInfo.DefaultFormState = (prefill = false, existingBasicInfo = null) => {
  return {
    firstName: prefill ? 'Reymundo' : (existingBasicInfo && existingBasicInfo.firstName) || '',
    lastName: prefill ? 'MATCH' + makeid(10) : (existingBasicInfo && existingBasicInfo.lastName) || '',
    state: prefill ? 'ID' : (existingBasicInfo && existingBasicInfo.state) || '',
    phone: prefill ? '(123) 345-4567' : (existingBasicInfo && existingBasicInfo.phone) || '',
  };
};

function makeid(l) {
  var text = "";
  var char_list = "abcdefghijklmnopqrstuvwxyz";
  for (var i = 0; i < l; i++) {
    text += char_list.charAt(Math.floor(Math.random() * char_list.length));
  }
  return text;
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Medicare/steps/BasicInfo.js